import React from "react";
import { Typography } from "@mui/material";
import Accordion from "@components/Accordion/Accordion";
import type { TransporterRow } from "@services/drybulkCargoOperationsApi";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.sequences.execution.transporters`;

/**
 * DBCO-0048 (R-42) - the distinct Transporters of the operation, with their contacts and planned quantity, exactly as returned.
 * Operations only: the data is absent from every other role's payload, so the accordion is not rendered without it.
 */
const TransportersAccordion: React.FC<{ transporters: TransporterRow[] }> = ({ transporters }) => {
  const { t } = useTranslation();
  return (
    <Accordion testId="transporters-accordion" summary={t(`${L}.title`)}>
      {transporters.length === 0 ? (
        <Typography variant="body2" color="text.secondary" data-testid="transporters-empty">
          {t(`${L}.empty`)}
        </Typography>
      ) : (
        <div className="flex flex-col gap-3">
          {transporters.map((row) => (
            <div
              key={row.companyCode ?? "-"}
              className="flex flex-col"
              data-testid={`transporter-${row.companyCode}`}
            >
              <Typography variant="subtitle2">
                {row.companyName
                  ? `${row.companyCode} - ${row.companyName}`
                  : (row.companyCode ?? "-")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t(`${L}.planned`)}: {row.planned ?? "-"}
              </Typography>
              {(row.contacts ?? []).map((contact, index) => (
                <Typography key={index} variant="body2">
                  {[contact.person, contact.number].filter(Boolean).join(" · ") || "-"}
                </Typography>
              ))}
            </div>
          ))}
        </div>
      )}
    </Accordion>
  );
};

export default TransportersAccordion;
